import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom, from } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { AppConfig } from '../../appconfig';
import { NetworkService } from '../../network.service';

export const authGuardWithForcedLoginFunction: CanActivateFn = async (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const appConfig = inject(AppConfig);
  const authService = inject(AuthService);
  const router = inject(Router);
  const networkService = inject(NetworkService);

  const networkstate = await firstValueFrom(networkService.state$);

  if (networkstate === 'offline') {
    return true;
  }
  return await firstValueFrom(
    authService.isDoneLoading$.pipe(
      filter((isDone) => isDone),
      switchMap((_) => authService.isAuthenticated$),
      tap((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }

        console.log('guard: state.url=', state.url);
        // when we are not authenticated, we have to check if we should show the login page
        if (appConfig.identityShowLogin()) {
          return from(router.navigate(['/login']));
        }

        // if we are not authenticated and the login page should not be shown, we have to login directly
        return authService.login(state.url);
      })
    )
  );
};
